<template>
  <div>
    <div class="taocan">
      <div>
        <div>
          <div
            style="
              text-align: left;
              font-size: 16px;
              font-weight: 600;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            特惠高速流量-月享6000G/单月-30天清零
          </div>
        </div>
        <div
          style="display: flex; justify-content: space-between; margin: 5px 0"
        >
          <div style="width: 50%; text-align: left">
            <div class="ax">
              开始:
              <span style="color: #009fff">2021-05-27 08:21:53</span>
            </div>
          </div>
          <div style="width: 50%; text-align: left">
            <div class="ax">
              失效:
              <span style="color: #009fff">2021-05-27 08:21:53</span>
            </div>
          </div>
        </div>
        <van-progress
          style="margin: 10px 0"
          :show-pivot="false"
          :percentage="50"
          stroke-width="8"
        />
        <div style="display: flex; justify-content: space-between">
          <div style="text-align: left">
            <div class="axs">
              总流量:
              <span>111111M</span>
            </div>
          </div>
          <div style="text-align: left">
            <div class="axs">
              已使用:
              <span>111111M</span>
            </div>
          </div>
          <div style="text-align: left">
            <div class="axs">
              未使用:
              <span>111111M</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Taocan",
  // props: ["msg", "cc"],
  data() {
    return {
      fom: [],
    };
  },
  methods: {
    router(s) {
      this.$router.push(`/detail/${s}/${localStorage.getItem("meCardNum")}`);
    },
  },
};
</script>

<style scoped lang="scss">
.taocan {
  border-radius: 10px;
  padding: 5px;
  margin-top: 10px;
  background-color: white;
  box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
}

.ax {
  // margin-bottom: 10px;
  font-size: 13px;
  color: rgba(128, 128, 128, 1);
  background-color: white;
}
.axs {
  font-size: 13px;
  font-weight: 700;
  background-color: white;
}
</style>
